/**
 * 现状只读：每个模块单独接口（业务表分页，不叠加待审）
 * object/resource 无分页；list 走 pageNo/pageSize
 */
export const MODULE_DATA_SOURCE = {
  // —— 工作室 ——
  GZSJIBENXINXI: { kind: "object", url: "/lx/liveState/base" },
  GZSTUANDUI: { kind: "list", url: "/lx/liveState/group" },
  GZSJIAOYANQINGKUANG: { kind: "list", url: "/lx/liveState/teachingResearch" },
  GZSZIJINYUSUAN: { kind: "list", url: "/lx/liveState/subsidyFund" },
  GZSZIJINZICHU: { kind: "list", url: "/lx/liveState/subsidyFundCost" },
  GZSKEYANQINGKUANG: { kind: "list", url: "/lx/liveState/researchSituation" },
  GZSHUODONGFANGAN: { kind: "list", url: "/lx/liveState/annualPlan" },
  GZSBIAOZHIXINGCHENGGUO: { kind: "list", url: "/lx/liveState/achievement" },
  GZSKCZSSZKC: { kind: "list", url: "/lx/liveState/activity" },
  GZSTUANDUIJIANSHE: { kind: "list", url: "/lx/liveState/teamBuilding" },
  GZSSHIJIANJIDI: { kind: "list", url: "/lx/liveState/cooperativeBase" },
  GZSJIDIHUODONG: { kind: "list", url: "/lx/liveState/practiceBase" },
  GZSRONGYU: { kind: "list", url: "/lx/liveState/honor" },
  PEIYUPINPAI: { kind: "list", url: "/lx/liveState/cultivateBrand" },

  // —— 品牌 ——
  PPJIBENXINXI: { kind: "object", url: "/lx/liveState/base" },
  PPTUANDUI: { kind: "list", url: "/lx/liveState/group" },
  PPZHIJINYUSUAN: { kind: "list", url: "/lx/liveState/subsidyFund" },
  PPZHIJINSHIYONG: { kind: "list", url: "/lx/liveState/subsidyFundCost" },
  PPNIANDUJIAHUAN: { kind: "list", url: "/lx/liveState/annualPlan" },
  PPHUODONG: { kind: "list", url: "/lx/liveState/activity" },
  PPJIANSHE: { kind: "list", url: "/lx/liveState/construction" },
  PPSIZHENGYUREN: { kind: "list", url: "/lx/liveState/ideological" },
  PPCHENGGUO: { kind: "list", url: "/lx/liveState/brandAchievements" },
  PPXUANCHUAN: { kind: "list", url: "/lx/liveState/promotion" },
  PPXIAOGUO: { kind: "list", url: "/lx/liveState/effect" },

  // —— 微课主单 ——
  WKJIBENXINXI: { kind: "object", url: "/lx/liveState/base" },
  WKTUANDUI: { kind: "list", url: "/lx/liveState/group" },
  WKSP: { kind: "resource", url: "/lx/liveState/resource" },
};

/** 基本信息额外展示字段（主单上有，但不在 FIELD_LABELS 对比字段里） */
export const BASIC_EXTRA_FIELDS = {
  1: {
    principals: "负责人",
    orgName: "所属单位",
    phone: "联系电话",
  },
  2: {
    principals: "负责人",
    orgName: "所属单位",
    phone: "联系电话",
  },
  3: {
    principals: "负责人",
    orgName: "所属单位",
  },
};

export function getModuleDataSource(taskType, applyType) {
  return MODULE_DATA_SOURCE[taskType] || null;
}
